import { format } from "date-fns-tz"

export class ReminderModel {
    constructor (data) {
        if (data) {
            // this.reminderId = data.reminderId
            this.id = data.id
            this.name = data.name ? data.name : ''
            this.event = data.event ? data.event : 0
            this.sender = data.sender ? data.sender : null
            this.content = data.content ? data.content : null
            this.initiator = data.initiator ? data.initiator : null
            this.receiver = data.receiver ? data.receiver : null
            this.status = data.status ? data.status : 0
            this.importance = (data.importance !== null && data.importance !== undefined) ? data.importance : 3
            this.dateFrom = data.dateFrom ? this._isoDate(data.dateFrom) : this._isoDate(new Date())
            this.dateTo = data.dateTo ? this._isoDate(data.dateTo) : this._isoDate(new Date())
            this.updateDate = data.updateDate ? this._updateDate(data.updateDate) : this._updateDate(new Date())
        } else {
            this.id = null
            this.name = ''
            this.event = 0
            this.sender = null
            this.content = null
            this.initiator = null
            this.receiver = null
            this.status = 0
            this.importance = 3
            this.dateFrom = this._isoDate(new Date())
            this.dateTo = this._isoDate(new Date())
            this.updateDate = this._updateDate(new Date())
        }
    }

    _isoDate (updateDate) {
        const date = new Date(updateDate)
        return format(date, "yyyy-MM-dd HH:mm", { timeZone: 'Asia/Yekaterinburg' })
    }

    _updateDate (updateDate) {
        const date = new Date(updateDate)
        // const minutes = Math.abs(date.getTimezoneOffset())
        // const local_date = add(date, { minutes: minutes })
        return format(date, "yyyy-MM-dd HH:mm:ss", { timeZone: 'Asia/Yekaterinburg' })
    }
}

export const ReminderEvent = [
    { text: "Свободное уведомление", value: 0 },
    { text: "Отчет о количестве зарегистрированных пользователей в лояльности", value: 1 },
    { text: "Сводный отчет по программам лояльности клиента", value: 2 },
    { text: "Терминал не на связи (offline)", value: 3 },
    { text: "Неуспешные платежи", value: 4 },
    { text: "Статистика по точкам продаж", value: 5 },
    { text: "Сводный отчёт по сверке итогов по точкам продаж", value: 6 },
    { text: "Отправка фискальных чеков", value: 7 },
    { text: "Сервер Justpay недоступен", value: 8 },
    { text: "Отчёт по сверке итогов (неуспешные статусы)", value: 9 },
    { text: "Отчёт по ошибкам платежей (сводный по кол-ву)", value: 10 },
    { text: "Сервис лояльности недоступен", value: 11 }
]

export const ReminderImportance = [
    { text: "Эктренное", value: 0, color: "red" },
    { text: "Предупреждение", value: 1, color: "orange" },
    { text: "Регулярное", value: 2, color: "blue" },
    { text: "Новостное", value: 3, color: "green" }]

const ReminderStatus = [
    { text: "Новый", value: 0 },
    { text: "Отправлено", value: 1 },
    { text: "Доставлено", value: 2 }
]

export const ReminderTitlesModel = [
    {
        text: "Наименование уведомления",
        value: "name",
        filterType: "text",
        filterValues: []
    },
    {
        text: "Текст уведомления",
        value: "content",
        filterType: "text",
        filterValues: []
    },
    {
        text: "Событие",
        value: "event",
        filterType: "list",
        filterValues: ReminderEvent.map((m, index) => {
            return Object.fromEntries([['text', m.text], ['value', index]])
        })
    },
    {
        text: "Важность",
        value: "importance",
        filterType: "list",
        filterValues: ReminderImportance.map((m, index) => {
            return Object.fromEntries([['text', m.text], ['value', index]])
        })
    },
    {
        text: "Статус",
        value: "status",
        filterType: "list",
        filterValues: ReminderStatus.map((m, index) => {
            return Object.fromEntries([['text', m.text], ['value', index]])
        })
    },
    {
        text: "Дата начала",
        value: "dateFrom",
        filterType: "date",
        filterValues: []
    },
    // {
    //     text: "Дата конца",
    //     value: "dateTo",
    //     filterType: "date",
    //     filterValues: []
    // },
    // {
    //     text: "Дата изменения",
    //     value: "updateDate",
    //     filterType: "date",
    //     filterValues: []
    // },
]

export const ReminderHeadersModel = ReminderTitlesModel.map(m =>
    Object.fromEntries(
        Object.entries(m)
            .filter(([key]) => ['text', 'value'].includes(key))
    )
)

export function getImportanceColor (item) {
    // console.log("getImportanceColor item", item)
    return ReminderImportance.find(i => i.value === item).color
}

export function getImportanceText (item) {
    return ReminderImportance.find(i => i.value === item).text
}

export function getEventText (item) {
    return ReminderEvent.find(i => i.value === item).text
}

export function getStatusText (item) {
    return ReminderStatus.find(i => i.value === item).text
}
